import axios from "axios"

async function buscarDadosEmpresas(params) {
    const batchGet = await _buscarDadosBatch(process.env.REACT_APP_ID_PLANILHA, ['EmpresasA2A2', 'ProdutosA2A2', 'VídeosA2A2', 'Contatos', 'PontosDeVendaA2A2', 'Imagens', 'Notícias'])

    const empresas = batchGet['EmpresasA2A2']
    const produtos = batchGet['ProdutosA2A2']
    const videos = batchGet['VídeosA2A2']
    const contatos = batchGet['Contatos']
    const pontosDeVenda = batchGet['PontosDeVendaA2A2']
    const imagens = batchGet['Imagens']
    const noticias = batchGet['Notícias']

    for (let i = 0; i < produtos.length; i++) {
        for (let j = 0; j < empresas.length; j++) {
            if (empresas[j]['Empresa'] === produtos[i]['Empresa']) {

                // Se a chave de produtos ainda não existir, criar ela como um array vazio
                if (!empresas[j]['Produtos']) {
                    empresas[j]['Produtos'] = []
                }

                empresas[j]['Produtos'].push(produtos[i])
                break
            }
        }

    }

    // Vídeos
    for (let i = 0; i < videos.length; i++) {
        for (let j = 0; j < empresas.length; j++) {
            if (empresas[j]['Empresa'] === videos[i]['Empresa']) {

                // Se a chave dos vídeos ainda não existir, criar ela como um array vazio
                if (!empresas[j]['Vídeos']) {
                    empresas[j]['Vídeos'] = []
                }

                empresas[j]['Vídeos'].push(videos[i])
                break
            }
        }
    }

    // Contatos
    for (let i = 0; i < contatos.length; i++) {
        for (let j = 0; j < empresas.length; j++) {
            if (empresas[j]['Empresa'] === contatos[i]['Empresa']) {

                // Se a chave dos contatos ainda não existir, criar ela como um array vazio
                if (!empresas[j]['Contatos']) {
                    empresas[j]['Contatos'] = []
                }

                empresas[j]['Contatos'].push(contatos[i])
                break
            }
        }
    }

    for (let i = 0; i < pontosDeVenda.length; i++) {
        const splitEmpresas = pontosDeVenda[i]['Empresas no ponto de venda'].split(', ')

        for (let j = 0; j < empresas.length; j++) {
            if (splitEmpresas.includes(empresas[j]['Empresa'])) {

                // Se a chave de pontos de venda ainda não existir, criar ela como um array vazio
                if (!empresas[j]['Pontos de venda']) {
                    empresas[j]['Pontos de venda'] = []
                }

                empresas[j]['Pontos de venda'].push(pontosDeVenda[i])
                break
            }
        }

    }

    // Imagens
    for (let i = 0; i < imagens.length; i++) {
        for (let j = 0; j < empresas.length; j++) {
            if (empresas[j]['Empresa'] === imagens[i]['Empresa'] && imagens[i]['A2A2']?.toUpperCase() === 'X') {

                // Se a chave das imagens ainda não existir, criar ela como um array vazio
                if (!empresas[j]['Imagens']) {
                    empresas[j]['Imagens'] = []
                }

                empresas[j]['Imagens'].push(imagens[i])
                break
            }
        }
    }

    // Notícias
    for (let i = 0; i < noticias.length; i++) {
        for (let j = 0; j < empresas.length; j++) {
            if (empresas[j]['Empresa'] === noticias[i]['Empresa'] && noticias[i]['A2A2']?.toUpperCase() === 'X') {

                // Se a chave das notícias ainda não existir, criar ela como um array vazio
                if (!empresas[j]['Notícias']) {
                    empresas[j]['Notícias'] = []
                }

                empresas[j]['Notícias'].push(noticias[i])
                break
            }
        }
    }

    return empresas
}

async function buscarDadosProdutos(params) {
    const dadosProdutos = await _buscarDados(process.env.REACT_APP_ID_PLANILHA, 'ProdutosA2A2')
    let produtosPorEmpresa = {}

    let produtosPorCategoria = {}

    dadosProdutos.map((produto) => {
        // Incluindo na lista de produtos por empresa
        if (!produtosPorEmpresa[produto['Empresa']]) {
            produtosPorEmpresa[produto['Empresa']] = []
        }

        produtosPorEmpresa[produto['Empresa']].push(produto)


        // Incluindo na lista de produtos Por categoria
        if (!produtosPorCategoria[produto['Categoria']]) {
            produtosPorCategoria[produto['Categoria']] = []
        }

        produtosPorCategoria[produto['Categoria']].push(produto)
    })

    // Ordenando categorias por ordem alfabética

    produtosPorCategoria = Object.fromEntries(Object.entries(produtosPorCategoria).sort())

    return { produtosPorEmpresa, produtosPorCategoria, categorias: Object.keys(produtosPorCategoria) }
}

async function buscarDadosProdutosSemSeparacaoPorEmpresa(params) {
    const batchGet = await _buscarDadosBatch(process.env.REACT_APP_ID_PLANILHA, ['ProdutosA2A2', 'VídeosProdutos', 'Imagens', 'Notícias'])

    const dadosProdutos = batchGet['ProdutosA2A2']
    const videos = batchGet['VídeosProdutos']
    const imagens = batchGet['Imagens']
    const noticias = batchGet['Notícias']

    // Vídeos
    for (let i = 0; i < videos.length; i++) {
        for (let j = 0; j < dadosProdutos.length; j++) {
            if (dadosProdutos[j]['Nome do produto/serviço'] === videos[i]['Produto/Serviço']) {

                // Se a chave dos vídeos ainda não existir, criar ela como um array vazio
                if (!dadosProdutos[j]['Vídeos']) {
                    dadosProdutos[j]['Vídeos'] = []
                }

                dadosProdutos[j]['Vídeos'].push(videos[i])

                break
            }
        }
    }

    // Imagens
    for (let i = 0; i < imagens.length; i++) {
        for (let j = 0; j < dadosProdutos.length; j++) {
            if (dadosProdutos[j]['Nome do produto/serviço'] === imagens[i]['Produto'] && imagens[i]['A2A2']?.toUpperCase() === 'X') {

                // Se a chave das imagens ainda não existir, criar ela como um array vazio
                if (!dadosProdutos[j]['Imagens']) {
                    dadosProdutos[j]['Imagens'] = []
                }

                dadosProdutos[j]['Imagens'].push(imagens[i])

                break
            }
        }
    }

    // Notícias
    for (let i = 0; i < noticias.length; i++) {
        for (let j = 0; j < dadosProdutos.length; j++) {
            if (dadosProdutos[j]['Nome do produto/serviço'] === noticias[i]['Produto'] && noticias[i]['A2A2']?.toUpperCase() === 'X') {

                // Se a chave das notícias ainda não existir, criar ela como um array vazio
                if (!dadosProdutos[j]['Notícias']) {
                    dadosProdutos[j]['Notícias'] = []
                }

                dadosProdutos[j]['Notícias'].push(noticias[i])

                break
            }
        }
    }

    return dadosProdutos
}

async function buscarDadosPontosDeVenda(params) {
    const dadosPontosDeVenda = await _buscarDados(process.env.REACT_APP_ID_PLANILHA, 'PontosDeVendaA2A2')

    let pontosDeVendaPorEmpresa = {}
    let pontosDeVendaPorEstado = {}
    let pontosDeVendaPorCidade = {}

    dadosPontosDeVenda.map((pontoDeVenda) => {
        // Incluindo na lista de pontos de venda por empresa
        const listaEmpresas = pontoDeVenda['Empresas no ponto de venda'].split(', ')
        for (let i = 0; i < listaEmpresas.length; i++) {
            if (!pontosDeVendaPorEmpresa[listaEmpresas[i]]) {
                pontosDeVendaPorEmpresa[listaEmpresas[i]] = []
            }

            pontosDeVendaPorEmpresa[listaEmpresas[i]].push(pontoDeVenda)
        }
        // Incluindo na lista de pontos de venda Por estado
        if (!pontosDeVendaPorEstado[pontoDeVenda['Estado']]) {
            pontosDeVendaPorEstado[pontoDeVenda['Estado']] = []
        }
        pontosDeVendaPorEstado[pontoDeVenda['Estado']].push(pontoDeVenda)
        // Incluindo na lista de pontos de venda Por cidade
        if (!pontosDeVendaPorCidade[pontoDeVenda['Cidade']]) {
            pontosDeVendaPorCidade[pontoDeVenda['Cidade']] = []
        }
        pontosDeVendaPorCidade[pontoDeVenda['Cidade']].push(pontoDeVenda)
    })

    // Ordenando estados e cidades por ordem alfabética
    pontosDeVendaPorEstado = Object.fromEntries(Object.entries(pontosDeVendaPorEstado).sort())
    pontosDeVendaPorCidade = Object.fromEntries(Object.entries(pontosDeVendaPorCidade).sort())

    return { pontosDeVendaPorEmpresa, pontosDeVendaPorEstado, estados: Object.keys(pontosDeVendaPorEstado), pontosDeVendaPorCidade, cidades: Object.keys(pontosDeVendaPorCidade) }
}
async function buscarDadosPontosDeVendaSemSeparacaoPorEmpresa(params) {
    return await _buscarDados(process.env.REACT_APP_ID_PLANILHA, 'PontosDeVendaA2A2')
}

async function buscarDadosPontoDeVenda(params) {
    const pontosDeVenda = await _buscarDados(process.env.REACT_APP_ID_PLANILHA, 'PontosDeVendaA2A2')
    const empresas = await _buscarDados(process.env.REACT_APP_ID_PLANILHA, 'EmpresasA2A2')
    // Criando array de empresas
    for (let i = 0; i < pontosDeVenda.length; i++) {
        pontosDeVenda[i]['Empresas no ponto de venda'] = pontosDeVenda[i]['Empresas no ponto de venda'].split(', ')
    }
    for (let i = 0; i < empresas.length; i++) {
        for (let j = 0; j < pontosDeVenda.length; j++) {
            if (pontosDeVenda[j]['Empresas no ponto de venda'].includes(empresas[i]['Empresa'])) {
                // Se a chave de empresas ainda não existir, criar ela como um array vazio
                if (!pontosDeVenda[j]['Empresas']) {
                    pontosDeVenda[j]['Empresas'] = []
                }
                pontosDeVenda[j]['Empresas'].push(empresas[i])
            }
        }
    }
    return pontosDeVenda
}


async function _buscarDados(idPlanilha, nomeAba) {
    const res = await axios.get(`https://sheets.googleapis.com/v4/spreadsheets/${idPlanilha}/values/${nomeAba}?key=${process.env.REACT_APP_SHEETS_KEY}`)

    const colunas = res.data.values[0]
    const linhas = res.data.values.slice(1, res.data.values.length)

    const objetos = []

    for (let i = 0; i < linhas.length; i++) {
        const objeto = {}

        for (let j = 0; j < linhas[i].length; j++) {
            objeto[colunas[j]] = linhas[i][j]
        }

        objetos.push(objeto)
    }

    return objetos
}

async function _buscarDadosBatch(idPlanilha, nomesAbas) {
    let rangesString = ''

    for (let i = 0; i < nomesAbas.length; i++) {
        rangesString += `&ranges=${nomesAbas[i]}`
    }

    const batchUrl = `https://sheets.googleapis.com/v4/spreadsheets/${idPlanilha}/values:batchGet?key=${process.env.REACT_APP_SHEETS_KEY}${rangesString}`

    const res = await axios.get(batchUrl)

    const ranges = res.data.valueRanges

    const resultado = {}

    for (let i = 0; i < nomesAbas.length; i++) {
        const colunas = ranges[i].values[0]
        const linhas = ranges[i].values.slice(1, ranges[i].values.length)

        const objetos = []

        for (let i = 0; i < linhas.length; i++) {
            const objeto = {}

            for (let j = 0; j < linhas[i].length; j++) {
                objeto[colunas[j]] = linhas[i][j]
            }

            objetos.push(objeto)
        }

        resultado[nomesAbas[i]] = objetos
    }

    return resultado
}

const exports = { buscarDadosEmpresas, buscarDadosProdutos, buscarDadosProdutosSemSeparacaoPorEmpresa, buscarDadosPontoDeVenda, buscarDadosPontosDeVenda, buscarDadosPontosDeVendaSemSeparacaoPorEmpresa }

export default exports